module.exports = __webpack_public_path__ + "img/30.3.TP.974b8afc.png";